'use strict';

angular.module('cloudBillingLegacyFrontend').controller('TeamsChooseTeamMixinCtrl', function($scope, $modal, $controller, $q, $eaTeamManagement) {

  // Re-Using the object picker
  $.extend(self, $controller('ModalObjectPickerCtrlMixin', {$scope: $scope, $modal: $modal}));

  /*
   * Opens a team chooser and allows to select a specific team. Only teams where the user has the defined minimum
   * role will be shown. If only one team is choosable the function does not open a chooser it returns this team.
   * Should no team match the criteria it ends up with an error.
   */
  $scope.openTeamChooser = function(profile, activeTeamId, minimumRoleInTeam, $eaCurrentSession, options) {
    options = options || {};

    // load all the teams
    return $eaTeamManagement.getTeamProfilesByRole(profile, minimumRoleInTeam, false, $eaCurrentSession.DataToken).then(function(teamProfiles) {

      // check if we have no team
      if (!teamProfiles || teamProfiles.length === 0) { return $q.reject(); }

      // check if we have just one team
      if (teamProfiles.length === 1 && !options.allowPersonal) { return $q.when(teamProfiles[0].Id); }
      
      // define the selectedTeamProfile
      var selectedTeamProfile = teamProfiles[0];
      if (activeTeamId) {
        teamProfiles.forEach(function(t) {
          if (t.Id == activeTeamId) { selectedTeamProfile = t; }
        })
      }

      // prepare the callbacks
      var getImageUrl = function(model) {        
          return 'fa-buildings';        
      };

      var getDisplayName = function(model) {
        return model.Name;
      };

      var getDetailsString = function(model) {
        if (model.Role === 'admin') {
          return 'Your role in this tenant is administrator';
        } else {
          return 'Your role in this tenant is member';
        }
      };

      var description = 'You are using an account which is part of several tenants, please choose the teant you want to switch to:';

      return $scope.openObjectPickerDialog('Choose a tenant', description, getImageUrl, getDisplayName, getDetailsString, teamProfiles, [selectedTeamProfile], true).then(function(selectedTeamProfile) {
        return selectedTeamProfile.Id;
      })
    });
  };
});
